import { render, staticRenderFns } from "./LayoutRouter.vue?vue&type=template&id=250a4bfe&"
import script from "./LayoutRouter.vue?vue&type=script&lang=js&"
export * from "./LayoutRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports